import { render, staticRenderFns } from "./PaymentPickups.vue?vue&type=template&id=72a664d8&"
import script from "./PaymentPickups.vue?vue&type=script&lang=js&"
export * from "./PaymentPickups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports